import React from 'react'
import '../styles/Sidebar.scss'

import Menu from './Menu'

const Sidebar: React.FC<{ isOpen: boolean, closeSidebar: () => void }> = ({ isOpen, closeSidebar }) => {
  return (
    <>
      <div className={`row sidebar ${isOpen ? 'open' : ''}`} onClick={closeSidebar}>
        <img src={`${process.env.PUBLIC_URL}/img/logo-white.png`} className="col-10" alt="Logo" />
        <Menu />
      </div>
      <div className={`sidebar-bg ${isOpen ? 'open' : ''}`} onClick={closeSidebar} />
    </>
  )
}

export default Sidebar
